import React, { useRef, useEffect } from "react";
import { useRouter } from "next/router";
import { Chart, registerables } from "chart.js";
import { CATEGORIES } from "../../data/diagnosticQuestions";
import styles from "./ResultsRadarChart.module.scss";

Chart.register(...registerables);

export default function ResultsRadarChart({ categoryScores, recommendation }) {
    const canvasRef = useRef(null);
    const chartRef = useRef(null);
    const { locale } = useRouter();

    const labels = CATEGORIES.map((c) =>
        locale === "en" ? c.name_en : c.name_is,
    );
    const data = CATEGORIES.map((c) => categoryScores[c.id] || 0);
    const chartColor = "#009448";

    useEffect(() => {
        if (!canvasRef.current) return;

        if (chartRef.current) {
            chartRef.current.destroy();
        }

        chartRef.current = new Chart(canvasRef.current, {
            type: "radar",
            data: {
                labels,
                datasets: [
                    {
                        data,
                        backgroundColor: "rgba(0, 148, 72, 0.08)",
                        borderColor: chartColor,
                        borderWidth: 2,
                        pointBackgroundColor: "#fff",
                        pointBorderColor: chartColor,
                        pointBorderWidth: 2,
                        pointRadius: 4,
                        pointHoverRadius: 6,
                        fill: true,
                    },
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: true,
                scales: {
                    r: {
                        min: 0,
                        max: 5,
                        ticks: {
                            stepSize: 1,
                            color: "#bbb",
                            backdropColor: "transparent",
                            font: { size: 9 },
                        },
                        grid: { color: "#e5e7eb" },
                        angleLines: { color: "#e5e7eb" },
                        pointLabels: {
                            color: "#555",
                            font: { size: 10, weight: "500" },
                            padding: 16,
                        },
                    },
                },
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        backgroundColor: "#fff",
                        titleColor: "#333",
                        bodyColor: "#666",
                        borderColor: "#e5e7eb",
                        borderWidth: 1,
                        callbacks: {
                            label: (ctx) => `${ctx.raw} / 5.0`,
                        },
                    },
                },
            },
        });

        return () => {
            if (chartRef.current) chartRef.current.destroy();
        };
    }, [categoryScores, recommendation, locale]);

    return (
        <div className={styles.radarContainer}>
            <canvas ref={canvasRef} />
        </div>
    );
}
